














































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import ChangePasswordDto from "../../../store/dto/ChangePasswordDto";
@Component
export default class UpdatePassword extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  changepassworddto: ChangePasswordDto = new ChangePasswordDto();
  created() {}
  save() {
    (this.$refs.passwordForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "session/changePassword",
          data: this.changepassworddto,
        });
        (this.$refs.passwordForm as any).resetFields();
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.passwordForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  validatePassCheck = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback(new Error(this.L("ConfirmPasswordMsg")));
    } else if (value !== this.changepassworddto.newPassword) {
      callback(new Error(this.L("ConfirmPasswordNotMatch")));
    } else {
      callback();
    }
  };
  pwRule = {
    currentPassword: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Password")),
        trigger: "blur"
      }
    ],
    newPassword: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Password")),
        trigger: "blur"
      }
    ],
    repeatPassword: {
      required: true,
      validator: this.validatePassCheck,
      trigger: "blur"
    }
  }
}
